<soho-header #SohoHeader [hasToolbar]="hasToolbar" [class.has-breadcrumb]="hasBreadcrumbs">

  <!--
  UPLIFT WORK - removing app title 
  [pageTitle]="webAppTitle"
    [attr.id]="toolbarId"
  -->
  <lm-toolbar
      [inHeader]="true"
      [automationId]="screenAutomationId"
      [showGoBack]="showGoBack"
      [sectionTitle]="toolbarSectionTitle"
      [toolbarIdPrefix]="screenId"
      [asOfDate]="asOfDate"
      [showArchive]="showArchive"
      [uploadInProgress]="uploadInProgress"
      [buttons]="toolbarButtons | async"
      [disabled]="disabled"
      [searchField]="toolbarSearchField"
      [mustacheText]="mustacheText"
      [isReportAsOfDate]="isReportAsOfDate"
      [moreMenuSettings]="toolbarMoreSettings"
      [isCreateReportMode]="isCreateReportMode"
      [showCalledOutMenuButton]="showCalledOutMenuButton"
      (toolbarBackButtonEvent)="onToolbarBackButtonEvent()"
      (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
      (toolbarSearchEvent)="onToolbarSearchEvent($event)"
      (toolbarSearchClearedEvent)="onToolbarSearchClearedEvent($event)"
      (asOfDateChangedEvent)="onAsOfDateChangedEvent($event)"
      (asOfDateClearedEvent)="onAsOfDateCleared()"
      (quitArchiveViewEvent)="onQuitArchiveView()"
      (quitProxyModeEvent)="onQuitProxyMode()"
      (quitDBSessionDebugModeEvent)="onQuitDBSessionDebugMode()"
      (quitSecSessionDebugModeEvent)="onQuitSecSessionDebugMode()"
      (quitListCostReportModeEvent)="onQuitListCostReportMode()"
      (updateReportAsOfDateEvent)="onUpdateReportAsOfDate()"
  ></lm-toolbar>

  @if (hasBreadcrumbs) {

    @if (useWC) {

      <div class="lm-banner-breadcrumbs-container">
        <ids-breadcrumb #breadcrumb color-variant="breadcrumb" truncate="true">
          @for (breadCrumbItem of breadcrumbs; track breadCrumbItem) {

            <ids-hyperlink
                font-size="14"
                tabindex="0"
                font-weight="breadCrumbItem.current === true ? 'semibold':null"
                color-variant="breadcrumb"
                [attr.target-id]="breadCrumbItem.id"
                text-decoration="hover"
            >{{breadCrumbItem.content}}</ids-hyperlink>
          
}
        </ids-breadcrumb>
      </div>
    
} @else {

      <section class="scrollable-flex-header has-breadcrumb">
        <nav #SohoBreadcrumb soho-breadcrumb class="breadcrumb" [breadcrumbs]="breadcrumbs" style="position: fixed;"></nav>
      </section>
    
}
    
  
}
</soho-header>
